export default {
	name: "מערכת הגרלות",
	logo: null,
	rtl: true,
};
